import { useRef, useState, useEffect } from 'react';
import './carrouselSponsoredLeft.sass';

export default function CarrouselSponsoredLeft({ dataFilters = [], selectedJson, selectedValue, setScrollPosition, scrollPosition, setIndexJson, showDropdownArrow = false }) {
  const scrollContainerRef = useRef(null);
  const [activeLeague, setActiveLeague] = useState(selectedValue?.id || '');
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  // Manejar selección de liga
  const handleSelect = (league, e) => {
    e.preventDefault();
    selectedJson(league);
    setActiveLeague(league.id);
    setIndexJson(league.index);
  };

  // Verificar visibilidad de flechas
  const updateArrowVisibility = () => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const { scrollLeft, scrollWidth, clientWidth } = container;
    setShowLeftArrow(scrollLeft > 0);
    setShowRightArrow(scrollLeft < scrollWidth - clientWidth);
  };

  // Manejar click en flechas con scroll suave
  const handleArrowClick = (direction) => {
    const container = scrollContainerRef.current;
    if (!container) return;
    container.scrollBy({ left: direction * 500, behavior: 'smooth' });
    setTimeout(updateArrowVisibility, 300);
  };

  // Configurar listeners
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      updateArrowVisibility();
      if (setScrollPosition) setScrollPosition(container.scrollLeft);
    };

    container.addEventListener('scroll', handleScroll);
    setTimeout(updateArrowVisibility, 100);

    return () => container.removeEventListener('scroll', handleScroll);
  }, [dataFilters, setScrollPosition]);

  // Sincronizar liga activa con el padre (soporta deselección con null)
  useEffect(() => {
    setActiveLeague(selectedValue?.id || '');
  }, [selectedValue]);

  return (
    <div className="carrousel-sponsored-left__select">
      {showLeftArrow && (
        <button
          className="arrow-left-nav"
          onClick={() => handleArrowClick(-1)}
          aria-label="Desplazar hacia la izquierda"
        />
      )}

      <div className="scroll-container" ref={scrollContainerRef}>
        <ul className="dropdown-menu league-nav">
          {dataFilters.map(({ id, name, url }, index) => {
            const isActive = activeLeague === id;
            return (
              <li key={`${name}-${id}`} style={{ flexShrink: 0 }}>
                <button
                  type="button"
                  onClick={(e) => handleSelect({ id, name, url, index }, e)}
                  className={`league${isActive ? ' activeItem' : ''}${showDropdownArrow ? ' league--dropdown' : ''}`}
                >
                  {name}
                  {showDropdownArrow && (
                    <svg
                      className={`league__arrow${isActive ? ' league__arrow--open' : ''}`}
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      </div>

      {showRightArrow && (
        <button
          className="arrow-right-nav"
          onClick={() => handleArrowClick(1)}
          aria-label="Desplazar hacia la derecha"
        />
      )}
    </div>
  );
}